import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-save-icon',
  template: `
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_31983_6466)">
        <path
          d="M13.5569 3L4.22352 3C3.36019 3 2.66797 3.7 2.66797 4.55556L2.66797 15.4444C2.66797 16.3 3.36019 17 4.22352 17H15.1124C15.968 17 16.668 16.3 16.668 15.4444V6.11111L13.5569 3ZM15.1124 15.4444H4.22352L4.22352 4.55556L12.9113 4.55556L15.1124 6.75667V15.4444ZM9.66797 10C8.37686 10 7.33464 11.0422 7.33464 12.3333C7.33464 13.6244 8.37686 14.6667 9.66797 14.6667C10.9591 14.6667 12.0013 13.6244 12.0013 12.3333C12.0013 11.0422 10.9591 10 9.66797 10ZM5.0013 5.33333H12.0013V8.44444H5.0013V5.33333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_31983_6466">
          <rect
            width="18.6667"
            height="18.6667"
            fill="currentColor"
            transform="translate(0.333984 0.666016)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveIconComponent {}
